<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong>Liste d'actualité</strong>
      </b-card-header>
      <b-card-body>
        <v-server-table ref="table" @loaded="onLoaded" :columns="columns" :url="url" :options="options">
          <div slot="date_debut" slot-scope="props">{{ formatDate(props.row.date_debut) }}</div>
          <div slot="date_fin" slot-scope="props">{{ props.row.date_fin !== null ? formatDate(props.row.date_fin) :
            'n.d' }}
          </div>
          <div slot="titre" slot-scope="props">{{ props.row.titre }}</div>
          <div slot="nature" slot-scope="props">{{ props.row.nature }}</div>
          <div slot="action" slot-scope="props">
            <b-button
              type="button"
              @click.prevent="destroy(props.row.id)"
              class="badge badge-danger mr-3 p-2">
              <i class="fa fa-remove"></i> Supprimer
            </b-button>
            <b-button
              type="button"
              @click="edit(props.row.id)"
              class="badge badge-primary p-2">
              <i class="fa fa-eye"></i> Voir
            </b-button>
          </div>
        </v-server-table>
      </b-card-body>
      <div slot="footer">
        <b-button type="button" @click="add" class="pull-right" size="md" variant="primary">
          <i class="fa fa-plus"></i> Ajouter une actualité
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";

  export default {
    name: "List",
    data() {
      let self = this;
      return {
        url: '',
        columns: ["date_debut", "date_fin", "titre", "nature", "action"],
        options: {
          headings: {
            date_debut: "Date de début",
            date_fin: "Date de fin",
            titre: "Titre",
            nature: "Nature",
            action: "Action",
          },
          sortable: ["titre", "nature"],
          filterable: false,
          perPage: 10,
          perPageValues: [10, 25, 50],
          texts: {
            filterPlaceholder: "Titre, Nature"
          },
          orderBy: {ascending: true},
          requestFunction: function (data) {
            self.url = '/espaceGestion/actualites'
            self.$store.commit("IS_LOADING", true);
            return axios.get(self.url)
              .catch(function (e) {
                self.$store.commit("IS_LOADING", false);
                self.$swal({
                  position: "top",
                  type: "error",
                  title: "Attention !!",
                  text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                  showConfirmButton: false,
                  timer: 5000
                });
              }.bind(this));
          },
          responseAdapter(data) {
            return {
              data: data.data.actualites,
              count: data.data.actualites.length
            }
          },
        }
      };
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    methods: {
      onLoaded() {
        this.$store.commit("IS_LOADING", false);
      },
      destroy(id) {
        let self = this;
        this.$swal.fire({
          title: 'Êtes-vous sûr?',
          text: "Voulez-vous supprimer cette actualité ?",
          type: 'warning',
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonColor: "#ff1744",
          confirmButtonText: 'Annuler',
          cancelButtonText: 'Supprimer',
        }).then((result) => {
          if (!result.value) {
            this.$store.commit('IS_LOADING', true);
            this.$axios
              .get(`/espaceGestion/actualites/delete/${id}`)
              .then(() => {
                this.$refs.table.refresh();
                this.$swal({
                  position: 'top',
                  type: 'success',
                  title: 'Suppression avec succès',
                  text: "L'actualité a bien été supprimée",
                  showConfirmButton: false,
                  timer: 3000
                });
              })
              .catch(function () {
                self.handleErrors(self);
              })
              .finally(() => {
                this.$store.commit('IS_LOADING', false)
              });
          }
        })
      },
      formatDate(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      },
      add() {
        this.$router.push({path: '/espace-gestion/actualite/add'})
      },
      edit(id) {
        this.$router.push({path: '/espace-gestion/actualite/details/' + id})
      },
      handleErrors(self) {
        self.$swal({
          position: 'top',
          type: 'error',
          title: 'Attention !!',
          text: "Une erreur est survenue lors de l'ajout de l'actualité. Si le problème persiste, merci de faire un ticket au support DOSI.",
          showConfirmButton: false,
          timer: 4000
        });
      }
    }
  }
</script>

<style scoped>

</style>
